import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import scan from "../../assets/module-2/2-2-10-scan.png";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";
import References from "../../components/References";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.2.10 Features of a Negative Scan
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row mt-5 mb-4 justify-content-center">
            <div className="col-lg-7 col-10">
              <FigureCaption
                noCollapse={true}
                className="figcaption-no-border align-items-center flex-column d-flex"
                radiusSize="small"
                textContent={
                  <>
                    <p className="gray">
                      &copy;2016. Avid Radiopharmaceuticals, Inc. All rights reserved. Data on file, Lilly Research Laboratories: AMY20121001G, AMY20121001C, AMY20121001D, AMY20121001E.
                    </p>
                  </>
                }
              >
                <LdsImage
                  src={scan}
                  alt="Four brain scan images comparing negative and positive Amyvid results. The left two images show negative scans with no significant amyloid plaque buildup, while the right two images show positive scans indicating the presence of amyloid plaques."
                />
              </FigureCaption>
            </div>
          </section>

          <section className="row mb-4 justify-content-center">
            <div className="col-12 col-lg-7">
              <ul className="ms-0">
                <li>Clear gray-white matter contrast</li>
                <li>White matter tracts clear from frontal to parietal lobe</li>
                <li>White matter tracts clear in occipital/temporal area</li>
                <li>
                  Scalloping appearance with some “fingers” of white matter in
                  frontal cortex
                </li>
              </ul>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-9", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-11", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>

          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection). Prescribing Information. Lilly USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
